import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { invalidateLibraryCache } from '@/hooks/useLibraryContent';
import { invalidateGeneratedCache } from '@/hooks/useGeneratedContent';

export const useMarkAsUsed = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const toggleUsed = async (ideaId: string, currentStatus: boolean, source?: 'scraped' | 'user_generated') => {
    setIsLoading(true);
    try {
      const tableName: 'user_generated_content' | 'content_ideas' = source === 'user_generated' ? 'user_generated_content' : 'content_ideas';
      
      const { error } = await supabase
        .from(tableName)
        .update({
          is_used: !currentStatus,
          used_at: !currentStatus ? new Date().toISOString() : null
        })
        .eq('id', ideaId);

      if (error) {
        console.error('Error toggling used status:', error);
        toast({
          title: "Błąd",
          description: "Nie udało się zaktualizować statusu użycia",
          variant: "destructive",
        });
        return false;
      }

      // Invalidate caches so other pages refetch fresh data
      invalidateLibraryCache();
      invalidateGeneratedCache();

      return true;
    } catch (error) {
      console.error('Error in toggleUsed:', error);
      toast({
        title: "Błąd",
        description: "Wystąpił nieoczekiwany błąd",
        variant: "destructive",
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    toggleUsed,
    isLoading
  };
};
